// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js??ref--10-1!../node_modules/.pnpm/postcss-loader@1.3.3/node_modules/postcss-loader/index.js??postcss!../node_modules/.pnpm/sass-loader@6.0.7_sass@1.77.8_webpack@2.4.1/node_modules/sass-loader/lib/loader.js??ref--10-3!./styles.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../node_modules/.pnpm/style-loader@0.13.2/node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js??ref--10-1!../node_modules/.pnpm/postcss-loader@1.3.3/node_modules/postcss-loader/index.js??postcss!../node_modules/.pnpm/sass-loader@6.0.7_sass@1.77.8_webpack@2.4.1/node_modules/sass-loader/lib/loader.js??ref--10-3!./styles.scss", function() {
			var newContent = require("!!../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/index.js??ref--10-1!../node_modules/.pnpm/postcss-loader@1.3.3/node_modules/postcss-loader/index.js??postcss!../node_modules/.pnpm/sass-loader@6.0.7_sass@1.77.8_webpack@2.4.1/node_modules/sass-loader/lib/loader.js??ref--10-3!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/src/styles.scss
// module id = ../../../../../../../../src/styles.scss
// module chunks = 2